import { INestedVenueCategory } from 'src/api/getVenueCategories/types';

/**
 * Collects the venue ids assigned to a category and every category beneath it.
 * A venue assigned to more than one category in the branch is only counted once.
 * @param {INestedVenueCategory} category - The category at the root of the branch
 * @returns {string[]} - The unique venue ids within the branch
 */
export const collectBranchVenueIds = (category: INestedVenueCategory): string[] => [
  ...new Set([...category.venue_ids, ...category.children.flatMap(collectBranchVenueIds)]),
];
